import Taak from "./Taak";
import { formatDateLong } from "../../helperfunctions/helperfunctions";
import { useState } from "react";

const Activiteit = (props) => {

    const [updatedActiviteit, setUpdatedActiviteit] = useState("");
    
    const includeUpdate = (result) => {
        setUpdatedActiviteit(result);
    }
    
    const activiteit = updatedActiviteit ? updatedActiviteit : props.activiteit;
    const { naam, omschrijving, datum, taken } = activiteit;

    const formatedDate = formatDateLong(datum);

    


    return (
        <div className="activiteitContainer">
            <div className="activiteitInsideLayer">
                <div className="activiteitTop">
                    <h2>{naam}</h2>
                    <p className="activiteitDatum">{formatedDate}</p>
                    <div className="activiteitOmschrijving">
                        <p>{omschrijving}</p>
                    </div>
                    

                </div>
                <div className="activiteitTakenContainer">
                    {taken && taken.map(taak => <Taak 
                        taak={taak} 
                        activiteit ={activiteit}
                        includeUpdate = {includeUpdate}
                        key={taak._id}/>)}

                </div>
            </div>
        </div>
    );
}

export default Activiteit;